'use client';

// Host storage adapter for @aumonline/individuals.
import { api } from "./api";

const unwrap = async (p) => (await p).data;

export const createIndividualsStorage = () => ({
  listIndividuals: (params) => unwrap(api.get("/individuals", { params })),
  createIndividual: (body) => unwrap(api.post("/individuals", body)),
  updateIndividual: (id, body) => unwrap(api.put(`/individuals/${id}`, body)),
  deleteIndividual: (id) => unwrap(api.delete(`/individuals/${id}`)),
});
